import { produce } from 'immer';
import { useCallback } from 'react';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { NodeStateUpdateType } from 'flow-builder/types/state';
import { updateRelayedConnector, updateRelayedNode, } from 'flow-builder/utils/canvas/updateRelayed/updateRelayed';
export const useUpdateNodeHeight = ({ setNodeState, relayedConnectorsRef, relayedNodesRef, }) => useCallback((items) => {
    setNodeState(produce(({ relations, connections, changes }) => {
        changes.unshift(NodeStateUpdateType.NodeHeightChange);
        Object.entries(items).forEach(([id, height]) => {
            const { parentId, children, connections: nodeConnections, } = relations[id];
            /*
             * If node height does not exist,
             * then this means that it's a new node.
             *
             * If it has children that are action nodes
             * we should offset them with the new node height.
             */
            if (relations[id].height === 0) {
                children.forEach((childId) => {
                    const connection = connections[childId];
                    const relation = relations[childId];
                    if (relation.nodeType !== FlowNodeTypes.ACTION) {
                        return;
                    }
                    relation.pageY += height;
                    connection.endY += height;
                    updateRelayedConnector(childId, { endY: connection.endY }, relayedConnectorsRef);
                    updateRelayedNode(childId, relation, relayedNodesRef);
                });
            }
            relations[id].height = height;
            if (parentId && connections[parentId]) {
                const changes = {
                    target: {
                        height,
                    },
                };
                connections[parentId].target.height = height;
                updateRelayedConnector(parentId, changes, relayedConnectorsRef);
            }
            nodeConnections.forEach((nodeConnection) => {
                const connectinId = nodeConnection.connection || nodeConnection.id;
                const { [connectinId]: connection } = connections;
                if (!connection) {
                    return;
                }
                const changes = {
                    offset: Object.assign(Object.assign({}, connection.offset), { y: height }),
                };
                connection.offset = changes.offset;
                updateRelayedConnector(id, changes, relayedConnectorsRef);
            });
        });
    }));
}, [setNodeState, relayedConnectorsRef, relayedNodesRef]);
